import applyFilters from './applyFilters'
import changePage from './changePage'
import clearAll from './clearAll'
import clearSelectedFilters from './clearSelectedFilters'
import removeFilterByValue from './removeFilterByValue'
import sortSelected from './sortSelected'

const actions = {
  clearAll: clearAll,
  sortSelected: sortSelected,
  changePage: changePage,
  applyFilters: applyFilters,
  clearSelectedFilters: clearSelectedFilters,
  removeFilter: removeFilterByValue,
}

export default actions
